import React, {useEffect, useState} from "react";
import {locations} from "../../Utilities/Location";
import {passwordApi} from "./passwordApi";
import {PasswordUpdateView} from "./PasswordUpdateView";
import {LayoutHero} from "../../Components/Layout/";

interface PasswordUpdateContainerProps {
    handleApiCall: (...args: unknown[]) => unknown;
    isLoading: boolean;
    redirect: (path: string) => void;
    setWarnings: (val: string[]) => void;
    updatePasswordToken: string;
}

export const PasswordUpdateContainer: React.FC<PasswordUpdateContainerProps> = ({
                                     handleApiCall,
                                     isLoading,
                                     redirect,
                                     setWarnings,
                                     updatePasswordToken,
                                 }) => {

    const [linkValidated, setLinkValidated] = useState(false);

    const handleUpdatePassword = (password: string) => {
        handleApiCall(() => passwordApi.updatePassword({password, updatePasswordToken: updatePasswordToken}),
            redirect(locations.SIGN_IN.path));
    };

    const validateUpdatePasswordLink = () => {
        handleApiCall(() => passwordApi.validateUpdatePasswordLink(updatePasswordToken),
            setLinkValidated,
            setLinkValidated(false));
    }

    useEffect(() => {
        if (!linkValidated)
            validateUpdatePasswordLink();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LayoutHero>
            <PasswordUpdateView
                handleUpdatePassword={handleUpdatePassword}
                isLoading={isLoading}
                setWarnings={setWarnings}
                isLinkExpired={!linkValidated}/>
        </LayoutHero>
    );
};
